export default "__VITE_ASSET__DkVVqsp8__"